export default "__VITE_ASSET__CTjt0hnv__"